<template>
  <div>
    <div id="pagestart" class="relative">
      <!--div class="pointer-events-none lg:hidden absolute top-0 w-1/2 h-full" :style="'left: 25%; z-index: 100; background-image: url(/facit/index_mobile.png); background-size: 200% auto; background-position: 50% 0; background-repeat: no-repeat'">
        
      </div-->
      <!--div class=" lg:inline absolute top-0 w-full h-full" :style="'left: 25%; z-index: 100; background-image: url(/facit/home.png); background-size: 100% auto; background-position: 0% 0; background-repeat: no-repeat'">
        
      </div-->

      <!-- FRONT PAGE ARTICLES -->
      <ContentFrontPageSection v-for="(article, index) in frontPageArticles"
        :key="article.id" :article="article" :index="index" :scrollprogress="scrollprogress" />
      
        <!-- GRAVAA TECH SLIDER -->
        <ContentGravaaSystemSlider class="mt-4 pt-14 lg:mx-8 lg:mt-7 lg:pt-32 bg-gravaasuperlightwarmgray" />

        <!-- GRAVAA HIGHLIGHTS -->
        <ContentGravaaHighlightsList class="bg-gravaasuperlightwarmgray lg:mx-8" />

        <!-- SOCIAL PROOF ARTICLES FORCE INDEX 1 for header layout change -->
        <ContentFrontPageSection v-for="(article, index) in blogStore.filterArticlesByTag(blog, 'Socialbanner')"
          :key="article.id" :article="article" :index="1" />


        <ContentGravaaWheels />

        <ContentPartnerLogos />

        <ContentFeaturedPages v-if="homepage?.featuredPages" :page="homepage" />
      

    </div><!-- end scrollcontainer-->
  </div>
</template>

<script setup>

import { useBlogStore } from '@/stores/blogStore';
import { usePageStore } from '@/stores/pageStore';

const { proxy } = useScriptGoogleTagManager({ id: 'GTM-TXPLJB8M' })

const { getSeoPageMeta } = useImageUtils();

const ContentGravaaSystemSlider = defineAsyncComponent(() => import('@/components/content/GravaaSystemSlider.vue'))
const ContentGravaaHighlightsList = defineAsyncComponent(() => import('@/components/content/GravaaHighlightsList.vue'))
const ContentGravaaWheels = defineAsyncComponent(() => import('@/components/content/GravaaWheels.vue'))
const ContentPartnerLogos = defineAsyncComponent(() => import('@/components/content/PartnerLogos.vue'))
const ContentFeaturedPages = defineAsyncComponent(() => import('@/components/content/FeaturedPages.vue'))
const ContentFrontPageSection = defineAsyncComponent(() => import('@/components/content/FrontPageSection.vue'))


var mounted = ref(false);

const frontPageArticles = computed(() => {
  return blogStore.filterArticlesByTag(blog.value, 'Herobanner');
});


const scrollprogress = ref(0);

// Get the Pinia store
const blogStore = useBlogStore();

const pageStore = usePageStore();


// FYI TOP LEVEL AWAIT BREAKS HOT REPLACE/RELOAD
const { data: blog, pending, error: blogError } = await useAsyncData('frontpage-blog', () => {
  return blogStore.fetchBlogByHandle('frontpage')
});


const { data: homepage, error } = await useAsyncData('homepage', () =>
  pageStore.fetchPageByHandle('home')
)

const updateScrollProgress = () => {
  scrollprogress.value = window.scrollY || 0;
};

onMounted(async () => {

  window.addEventListener('scroll', updateScrollProgress);
  updateScrollProgress();
  mounted.value = true;

  console.log('Pushing page_view for home page to GTM dataLayer');
  proxy.dataLayer.push({ 
    event: 'page_view', 
    pageType: 'home page',
    pageUrl: window.location.href,
    pageTitle: homepage.value.seo.title
  })

});

onUnmounted(() => {
  window.removeEventListener('scroll', updateScrollProgress);
});

// SEO
if (homepage.value) {
  useSeoMeta(getSeoPageMeta(homepage.value));    
}


</script>
